import _ from "d3";

window.d3 = _;
